import React from "react";
import { Portal } from "./../module/portal";
import { Faq } from "./../module/faq";
import { Manual } from "./../module/manual";
import { ViewHistory } from "./../module/import-history";
import { UploadScreen } from "./../module/import-file";
import { QueryScreen } from "./../module/direct-query";
import { ExportQuery } from "./../module/export-query";
import { RouteLayout, RouteLayout2 } from "./../template/RouteLayout";
import { UserMaintenance } from "./../module/user-maintenace";
import { TopicTypeMaster } from "./../module/topic-type-master";
import { DecryptScreen } from "./../module/decrypt-screen";
import { ExportHistory } from "./../module/export-history";
import { EncryptMapMaster } from "../module/encrypt-map-master";
import { RoleMaintenance } from "../module/role-maintenance";
import { ModuleMaintenance } from "../module/module-maintenance";
import { RoleModuleMaintenance } from "../module/role-module-maintenance";
import { ExtendOutbound } from "../module/extend-outbound";
import BannerMaster from "../module/master/banner-master";
import { JobSchedule } from "../module/job-schedule";
import { ScheduleManagement } from "../module/job-schedule-management";
import { ScheduleQuota } from "../module/job-schedule-quota";
import { ScheduleMonitor } from "../module/job-schedule-monitor";
import { ConfigSpiAuthorize } from "../module/config-spi-authorize";
import { ConfigTemplateAuthorize } from "../module/config-template-authorize";
import { ConfigMasterTemplate } from "./../module/config-master-template";
import { UserDataManagement } from "./../module/user-data-management";
const route = [
  {
    path: "/",
    component: Portal,
  },
  {
    path: "/Manual",
    component: Manual,
  },
  {
    path: "/Faq",
    component: Faq,
  },
];
export const route2 = [
  {
    path: "/Home",
    component: Portal,
    ScreenName: "Home", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/DirectQuery",
    component: QueryScreen,
    ScreenName: "Direct Query", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/TextLoader",
    component: ViewHistory,
    ScreenName: "Text Loader", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/User-Maintenance",
    component: UserMaintenance,
    ScreenName: "User Maintenance", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/Topic-Type-Master",
    component: TopicTypeMaster,
    ScreenName: "Topic Type", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/UploadCSV",
    component: UploadScreen,
    ScreenName: "Import CSV",
  },
  {
    path: "/DecryptScreen",
    component: DecryptScreen,
    ScreenName: "Decrypt Table",
  },
  {
    path: "/ExportHistory",
    component: ExportHistory,
    ScreenName: "Decrypt Export", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/ExportQuery",
    component: ExportQuery,
    ScreenName: "Export Query", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/ExtendOutbound",
    component: ExtendOutbound,
    ScreenName: "Extend Outbound", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/EncryptMapMaster",
    component: EncryptMapMaster,
    ScreenName: "Encrypt Map Master", //ScreenName Must Equal Module Name in SqlDB
  },
  {
    path: "/Role-Maintenance",
    component: RoleMaintenance,
    ScreenName: "Role Maintenance",
  },
  {
    path: "/Module-Maintenance",
    component: ModuleMaintenance,
    ScreenName: "Module Maintenance",
  },
  {
    path: "/RoleModule-Maintenance",
    component: RoleModuleMaintenance,
    ScreenName: "Role-Module Maintenance",
  },
  {
    path: "/Master/Announcement",
    component: BannerMaster,
    ScreenName: "Announcement",
    //,HELPER_NAME:'JobTypeMaster'
  },
  {
    path: "/JobSchedule",
    component: JobSchedule,
    ScreenName: "Job Scheduler",
  },
  {
    path: "/ScheduleManagement",
    component: ScheduleManagement,
    ScreenName: "Schedule",
  },
  {
    path: "/ScheduleQuota",
    component: ScheduleQuota,
    ScreenName: "Schedule Quota Additional",
  },
  {
    path: "/ScheduleMonitor",
    component: ScheduleMonitor,
    ScreenName: "Monitor Task",
  },
  {
    path: "/ConfigSpiAuthorize",
    component: ConfigSpiAuthorize,
    ScreenName: "Config SPI Authorize",
  },
  {
    path: "/UserDataManagement",
    component: UserDataManagement,
    ScreenName: "User Data Management",
  },
  {
    path: "/ConfigMasterTemplate",
    component: ConfigMasterTemplate,
    ScreenName: "Config Master Template",
  },
  {
    path: "/ConfigTemplateAuthorize",
    component: ConfigTemplateAuthorize,
    ScreenName: "Config template authorize",
  },
];
export const ProtectedRoutes = () => {
  //if(!CheckToken()){
  //        history.replace('/Login')
  //            let urlSaml = `${API_URL.Authen}/auth/Login?returnUrl=/`;
  //            window.location.replace(urlSaml);
  //    return null;
  //}
  return (
    <>
      {route.map((el, idx) => (
        <RouteLayout key={idx} exact path={el.path} component={el.component} />
      ))}
      {route2.map((el, idx) => (
        <RouteLayout2
          key={idx}
          exact
          path={el.path}
          component={el.component}
          ScreenName={el.ScreenName}
        />
      ))}
    </>
  );
};
ProtectedRoutes.route = Object.values(
  route.concat(route2).map((el) => el.path)
);
